import { createContext, useContext, useState, useCallback } from "react";

const AppointmentContext = createContext(null);

export const useAppointment = () => useContext(AppointmentContext);

export function AppointmentProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [defaultService, setDefaultService] = useState("");

  const openDialog = useCallback((service = "") => {
    setDefaultService(service);
    setOpen(true);
  }, []);

  return (
    <AppointmentContext.Provider value={{ open, setOpen, openDialog, defaultService }}>
      {children}
    </AppointmentContext.Provider>
  );
}
